module.exports = __webpack_public_path__ + "img/migrants-2011.515b8b92.png";